import {
  HttpErrorResponse,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { getApiErrorMessage } from '@app/api/utils/api-error.utils';
import { ToastService } from '@shared/ui';
import { catchError, throwError } from 'rxjs';

export const httpErrorInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  const toastService = inject(ToastService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      const detail = getApiErrorMessage(error);

      toastService.open(detail, undefined, 'error');

      return throwError(() => error);
    }),
  );
};
